module.exports = __webpack_public_path__ + "images/portfolio3-6fc1856795f2ec16dc4fb6b572009943.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/portfolio3.jpg
// module id = 16
// module chunks = 0